import MuiTextField from '@mui/material/TextField';
import React, { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

export const TextField: FC<FieldRenderProps> = ({
  input: { name, onChange, value, ...restInput },
  meta,
  ...rest
}) => {
  const errorMessage =
    (meta.touched && meta.error) ||
    (!meta.dirtySinceLastSubmit && meta.submitError);

  return (
    <MuiTextField
      {...rest}
      name={name}
      helperText={errorMessage || undefined}
      error={Boolean(errorMessage)}
      inputProps={restInput}
      onChange={onChange}
      value={value}
      variant="standard"
    />
  );
};
